import createEntity from "./createEntity"
import api from './../api';

const tenantList = createEntity();

const getTenantState = () => {
    return {
        state: {
            name: "",
            organization: "",
            domain: ""
        },
        modules: {
            users: createEntity({ namespaced: false })
        },
        actions: {
            async insertAdmin({ commit, state, getters }, { user }) {
                const existingEmail = getters['users/query'](u => u.email == user.email);
                if (existingEmail.length == 0) {
                    commit('users/add', user)
                } else {
                    throw new Error('The email exists in the administrator list.');
                }
            },
            deleteAdmin({ commit }, { data: admin }) {
                commit('users/deleteByEmail', admin.email)
            },
            reset({ commit }) {
                commit('reset');
                commit('users/load', []);
            }
        },
        mutations: {
            setName(state, name) {
                state.name = name;
            },
            setOrganization(state, organization) {
                state.organization = organization;
            },
            setDomain(state, domain) {
                state.domain = domain;
            },
            reset(state) {
                state.name = '';
                state.organization = '';
                state.domain = '';
            },
            setTenantDetails(state, tenant) {
                state.name = tenant.name;
                state.organization = tenant.organization;
                state.domain = tenant.domain;
            }
        },
        namespaced: false
    }
}

const state = {
    loading: false
}
const mutations = {
    setLoading(state, loading) {
        state.loading = loading;
    },
    stopLoading(state) {
        state.loading = false
    }
}
const actions = {
    async addTenant({ state, dispatch, commit, getters }) {
        if (!state.tenant.name || !state.tenant.organization || !state.tenant.domain) {
            throw new Error('Please fill in required fields');
        }
        const users = getters['users/getAll'];

        if (!users.length) {
            throw new Error('Please add at least one administrator.');
        }
        commit('setLoading', true)
        const tenant = {
            ...state.tenant,
            users
        }
        await api.addTenant(tenant);
        commit('setLoading', false);
        await dispatch('reset')
    },
    async loadTenants({ commit }) {
        commit('setLoading', true);
        const tenants = await api.getAllTenants();
        commit('tenantList/load', tenants);
        commit('setLoading', false);
    },
    async removeTenant({ dispatch, commit }, { data: tenant }) {
        commit('setLoading', true);
        await api.removeTenant(tenant);
        await dispatch('loadTenants');
        commit('setLoading', false);
    },
    async loadTenant({ dispatch, commit }, tenantId) {
        commit('setLoading', true);
        const tenantDetails = await api.getTenantDetails(tenantId);
        commit('setTenantDetails', tenantDetails);
        commit('setLoading', false);
    },
    async updateTenant({ commit }, tenantId) {
        if (!state.tenant.name || !state.tenant.organization || !state.tenant.domain) {
            throw new Error('Please fill in required fields');
        }
        commit('setLoading', true);
        await api.updateTenant(tenantId, state.tenant);
        commit('setLoading', false);
    },
    async resetApiKeys({ commit }, tenantId) {
        if (!tenantId) {
            return;
        }
        commit('setLoading', true);
        const data = await api.resetApiKeys(tenantId);
        commit('setLoading', false);
        return data;
    }

}
const getters = {}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
        tenantList,
        tenant: getTenantState()
    }
}